import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";

const Chapter8_4 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welche zentrale Herausforderung besteht bei der gleichzeitigen Umsetzung von KRITIS-, NIS2- und DORA-Vorgaben?",
      options: [
        {
          value: "A",
          label:
            "Die Harmonisierung von Prozessen und Anforderungen, um Synergien zwischen den Reglements zu nutzen.",
        },
        {
          value: "B",
          label:
            "Die Entwicklung individueller Sicherheitspläne für jedes Reglement, unabhängig voneinander.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Wie können kleinere Finanzdienstleister die Umsetzung aller drei Regelwerke bewältigen?",
      options: [
        {
          value: "A",
          label:
            "Durch Partnerschaften mit spezialisierten Dienstleistern und die Nutzung behördlicher Unterstützungsprogramme.",
        },
        {
          value: "B",
          label:
            "Durch Verzicht auf einzelne Sicherheitsmaßnahmen aufgrund begrenzter Ressourcen.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 7_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
         
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "8_4",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("8_4"),
            });
          console.log("Dokument aktualisiert mit Kapitel 8_4.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "8_4",
              completedChapters: ["8_4"],
            });
          console.log("Dokument erstellt mit Kapitel 8_4");
        }

        navigate("/8_5"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  8: Regulatorische Anforderungen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Umsetzungsstrategien
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 8: Regulatorische Anforderungen
          </h3>
          <h2 className="text-center pb-5">Umsetzungsstrategien</h2>
          <img
            src="/images/strategie.png"
            alt="Strategie"
            style={{ position: "relative", maxWidth: "25%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h3 className="p-5">
            Herausforderungen für Finanzunternehmen bei der Umsetzung der
            KRITIS-, NIS2- und DORA-Vorgaben{" "}
          </h3>
          <p className="col-lg-11  mx-auto">
            Die KRITIS-, NIS2- und DORA-Vorgaben stellen Finanzunternehmen vor
            komplexe Herausforderungen, da sie unterschiedliche Aspekte der
            Cybersecurity und Resilienz adressieren. Eine koordinierte Umsetzung
            dieser Richtlinien ist jedoch nicht nur erforderlich, sondern bietet
            auch erhebliche Synergien, die die Einhaltung erleichtern und die
            Effizienz der Maßnahmen steigern können. Insbesondere
            Finanzinstitute können von einem integrierten Ansatz profitieren, da
            sie oft in den Geltungsbereich aller drei Regelwerke fallen.
            <h3 className="p-5">Gemeinsame Anforderungen und Synergien</h3>
            <p className="col-lg-11 mx-auto">
              Obwohl KRITIS, NIS2 und DORA unterschiedliche Schwerpunkte setzen,
              gibt es zahlreiche Überschneidungen, die eine einheitliche
              Umsetzung erleichtern:
            </p>
            <section class="p-5 text-start">
              <ul class="timeline">
                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">Risikomanagement:</h5>

                  <p>
                    <ul>
                      <li>
                        Alle drei Regelwerke verlangen von Unternehmen ein
                        umfassendes Risikomanagement, das die Identifikation,
                        Bewertung und Kontrolle von IT- und Cyberrisiken
                        umfasst.
                      </li>
                      <li>
                        Eine zentrale Risikomanagementplattform kann helfen,
                        Risiken effizient zu erfassen und Maßnahmen entsprechend
                        der Anforderungen aller drei Richtlinien zu
                        priorisieren.
                      </li>
                    </ul>
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">Meldepflichten:</h5>

                  <p>
                    <ul>
                      <li>
                        Sowohl NIS2 als auch DORA schreiben vor, dass
                        Sicherheitsvorfälle innerhalb kurzer Fristen gemeldet
                        werden müssen (z. B. 24 Stunden bei DORA).
                      </li>
                      <li>
                        Eine einheitliche Incident-Management-Struktur
                        erleichtert die Erfassung und Meldung von Vorfällen an
                        die zuständigen Aufsichtsbehörden.
                      </li>
                    </ul>
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">Sicherheitsüberprüfungen:</h5>

                  <p>
                    <ul>
                      <li>
                        Regelmäßige Tests der digitalen Resilienz, wie
                        <Link to="/2_1#pentest" className="icon-link">
                          <svg className="bi" aria-hidden="true">
                            <use xlinkHref="#book"></use>
                          </svg>{" "}
                          Penetrationstests
                        </Link>
                        und Stresstests, werden sowohl von NIS2 als auch von
                        DORA verlangt.
                      </li>
                      <li>
                        Durch die Konsolidierung von Testplänen und -methoden
                        können Ressourcen geschont und Doppelarbeit vermieden
                        werden.
                      </li>
                    </ul>
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">Drittanbieter-Management:</h5>

                  <p>
                    <ul>
                      <li>
                        Alle drei Richtlinien betonen die Bedeutung von
                        Sicherheitsstandards bei Drittanbietern und
                        Lieferketten.
                      </li>
                      <li>
                        Ein zentralisiertes Lieferantenmanagement-System kann
                        sicherstellen, dass alle Partnerunternehmen dieselben
                        hohen Sicherheitsanforderungen erfüllen.
                      </li>
                    </ul>
                  </p>
                </li>
              </ul>
            </section>
          </p>

          <div className="grey-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h2 className="col-lg-11 p-5 text-center mx-auto">
                  Spezifische Herausforderungen für Finanzunternehmen
                </h2>
                <p className="col-lg-11 text-center mx-auto">
                  Finanzinstitute müssen sich spezifischen Herausforderungen
                  stellen, um die Vorgaben der Regelwerke KRITIS, NIS2 und
                  DORA gleichzeitig umzusetzen:
                </p>

                <section class="p-5 text-start">
                  <ul class="timeline">
                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">Hoher administrativer Aufwand:</h5>

                      <p>
                        <ul>
                          <li>
                            Die parallele Einhaltung mehrerer Richtlinien
                            erfordert umfangreiche Dokumentation und
                            Berichterstattung, insbesondere bei
                            Sicherheitsüberprüfungen und Meldepflichten.
                          </li>
                          <li>
                            Finanzunternehmen sollten in
                            Automatisierungslösungen investieren, um Berichte
                            effizienter zu erstellen und Compliance-Daten
                            zentral zu verwalten.
                          </li>
                        </ul>
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">Fragmentierte Zuständigkeiten:</h5>

                      <p>
                        <ul>
                          <li>
                            Unterschiedliche Teams können für KRITIS-, NIS2- und
                            DORA-Anforderungen zuständig sein. Eine klare
                            Rollenverteilung und die Schaffung eines zentralen
                            Koordinators, wie z. B. eines{" "}
                            <strong>Compliance Managers, </strong> können die
                            Zusammenarbeit verbessern.
                          </li>
                        </ul>
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">Technologische Anpassungen:</h5>

                      <p>
                        <ul>
                          <li>
                            Finanzinstitute müssen sicherstellen, dass ihre
                            IT-Infrastruktur den neuesten Sicherheitsstandards
                            entspricht. Dazu gehören fortschrittliche{" "}
                            <Link to="/4_3#siem" className="icon-link">
                              <svg className="bi" aria-hidden="true">
                                <use xlinkHref="#book"></use>
                              </svg>{" "}
                              SIEM (Security Information and Event Management),
                            </Link>{" "}
                            Verschlüsselungstechnologien und
                            Echtzeit-Überwachung.
                          </li>
                          <li>
                            Cloud-Dienste müssen besonders streng kontrolliert
                            und auf ihre Resilienz geprüft werden, um die
                            Anforderungen aller drei Regelwerke zu erfüllen.
                          </li>
                        </ul>
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">Kosten:</h5>

                      <p>
                        <ul>
                          <li>
                            Die Umsetzung von Sicherheitsmaßnahmen, Schulungen
                            und die Einführung neuer Technologien erfordert
                            erhebliche finanzielle Ressourcen. Insbesondere
                            kleinere Finanzunternehmen können durch diese Kosten
                            stark belastet werden.
                          </li>
                        </ul>
                      </p>
                    </li>
                  </ul>
                </section>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  DORA könnte die Schaffung neuer Positionen wie
                  eines Digital Resilience Officers (DRO) erforderlich machen.
                  Diese Rolle umfasst die Koordination von Resilienzmaßnahmen,
                  die Zusammenarbeit mit Aufsichtsbehörden und die Überwachung
                  der IT-Sicherheitsstandards. Der DRO spielt eine zentrale
                  Rolle bei der Einhaltung der DORA-Anforderungen und stärkt die
                  digitale Widerstandsfähigkeit des Unternehmens.
                </p>
              </div>
            </div>
          </div>

          <div className="white-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">Vorteile eines integrierten Ansatzes</h3>
                <p className="col-lg-11 mx-auto">
                  Ein integrierter Ansatz zur Umsetzung von KRITIS-, NIS2- und
                  DORA-Vorgaben bietet nicht nur Effizienzgewinne, sondern auch
                  strategische Vorteile:
                  <br />
                  <br />
                  Durch die <strong>Bündelung von Prozessen, </strong> wie der
                  Incident-Meldung und der Durchführung von Tests, können in
                  Unternehmen Ressourcen effizienter genutzt und daruch Kosten
                  gespart werden.
                  <br />
                  <br />
                  Eine{" "}
                  <strong>
                    zentrale Plattform für Risikomanagement und
                    Berichterstattung{" "}
                  </strong>{" "}
                  erleichtert die Einhaltung der Anforderungen und verbessert
                  durch die erhöhte Transparenz die Kommunikation mit den
                  Aufsichtsbehörden.
                  <br />
                  <br />
                  Finanzinstitute, die die Richtlinien proaktiv umsetzen, können
                  ihr Engagement für Cybersecurity als Vertrauensvorsprung und{" "}
                  <strong>Wettbewerbsvorteil </strong>bei Kunden und Investoren
                  nutzen.
                </p>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Die enge Zusammenarbeit und Kommunikation mit Behörden,
                  Drittanbietern und Partnern stärkt die Fähigkeit der
                  Finanzinstitute, auf Cyberbedrohungen effektiv zu reagieren
                  und die regulatorischen Anforderungen von KRITIS, NIS2 und
                  DORA zu erfüllen. Durch die Teilnahme an kooperativen
                  Initiativen und den Austausch von Informationen können
                  Finanzinstitute Bedrohungen frühzeitig erkennen und sich auf
                  neue Risiken vorbereiten. Diese Zusammenarbeit erhöht nicht
                  nur die Widerstandsfähigkeit einzelner Unternehmen, sondern
                  auch die Sicherheit und Stabilität des gesamten Finanzsektors.
                </p>
              </div>
            </div>
          </div>

          <div className="gelb-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">
                  Auswirkungen auf kleine Finanzdienstleister
                </h3>
                <p className="col-lg-11 mx-auto">
                  Die Umsetzung der DORA-Verordnung stellt insbesondere kleine
                  und mittlere Finanzdienstleister (KMUs) vor große
                  Herausforderungen. Die strengen Anforderungen, wie regelmäßige
                  Resilienztests, umfassende Sicherheitsmaßnahmen und
                  detaillierte Berichterstattung, erfordern{" "}
                  <strong>
                    {" "}
                    erhebliche finanzielle und personelle Ressourcen.{" "}
                  </strong>{" "}
                  Für KMU, die oft nur begrenzte Mittel und anderweitig spezialisiertes
                  Fachpersonal zur Verfügung haben, können die damit verbundenen
                  Kosten und Komplexitäten überwältigend sein. Ein zentraler
                  Aspekt ist der <strong>Fachkräftemangel, </strong> da die
                  steigende Nachfrage nach IT-Sicherheitsexperten kleinere
                  Unternehmen benachteiligt. Zudem fehlen häufig die internen
                  Strukturen, um die notwendigen Prozesse effizient umzusetzen.
                  Die Abhängigkeit von Drittanbietern erhöht dabei das Risiko
                  und erfordert zusätzliche Aufwände für Überwachung und
                  Vertragsgestaltung.
                  <br />
                  <br />
                  Um diese Hürden zu bewältigen, könnten KMU auf Unterstützung
                  von Behörden oder spezialisierten Partnern zurückgreifen.
                  Behörden könnten Hilfestellung in Form von Leitlinien,
                  standardisierten Tools oder Schulungsprogrammen anbieten, um
                  die Umsetzung der DORA-Anforderungen zu erleichtern.
                  Partnerschaften mit IT-Dienstleistern oder Managed Security
                  Services könnten ebenfalls eine Lösung bieten, um
                  Sicherheitsmaßnahmen auszulagern und kosteneffizient
                  umzusetzen.
                </p>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Die Einhaltung von DORA kann für KMUs zwar eine
                  Herausforderung darstellen, bietet jedoch auch Chancen, die
                  Cybersecurity zu verbessern und das Vertrauen von Kunden und
                  Partnern zu stärken. Ein strategischer Ansatz und gezielte operative
                  Unterstützung sind entscheidend, um die Anforderungen zu
                  erfüllen und langfristig wettbewerbsfähig zu bleiben.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container pt-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />

            <h3 className="p-5">
              {" "}
              Zukunftsausblick auf die Weiterentwicklung der
              Cybersecuritysanforderungen im Finanzsektor
            </h3>

            <p className="col-lg-11 mx-auto">
              Angesichts steigender Bedrohungen und technischer Innovationen
              stehen Finanzinstitute vor der Herausforderung, ihre
              Sicherheitsstandards kontinuierlich zu verbessern und flexibel auf
              neue Gefahren zu reagieren. Hier sind einige der zentralen Trends
              und potenziellen Entwicklungen: <br />
              <br />
              <strong>
                Erweiterte Anforderungen an die Resilienz gegenüber komplexeren
                Cyberangriffen:{" "}
              </strong>
              Cyberangriffe werden zunehmend komplexer und gezielter, und
              Finanzinstitute müssen daher immer ausgefeiltere Abwehrstrategien
              implementieren. Die regulatorischen Anforderungen werden demnach
              noch umfassendere Resilienzmaßnahmen und eine intensivere
              Überwachung der Systemintegrität fordern. In der Zukunft könnten
              Regelwerke spezifische Anforderungen an die Detektion und Reaktion
              auf hochentwickelte Angriffe enthalten, etwa durch
              Echtzeit-Monitoring und verbesserte Anomalieerkennung. <br />
              <br />
              <strong>
                Verpflichtende Nutzung von KI und Automatisierung zur
                Bedrohungserkennung:{" "}
              </strong>
              Die Rolle von Künstlicher Intelligenz (KI) und Automatisierung in
              der Cybersecurity wird weiter an Bedeutung gewinnen. KI-gestützte
              Systeme können dabei helfen, Bedrohungen schneller und präziser zu
              erkennen und automatisiert auf Sicherheitsvorfälle zu reagieren.
              Zukünftige Vorschriften könnten die Nutzung solcher Technologien
              zur Bedrohungserkennung und zur Analyse großer Datenmengen zur
              Pflicht machen, um eine noch schnellere Reaktion auf komplexe
              Angriffe zu ermöglichen. <br />
              <br />
              <strong>
                Fokus auf die Sicherheit und Resilienz von Cloud-Diensten und
                hybriden Infrastrukturen:{" "}
              </strong>
              Mit der zunehmenden Nutzung von Cloud-Technologien im Finanzsektor
              wird die Sicherheit von Cloud-Umgebungen zu einem immer
              wichtigeren Thema. Regulatorische Anforderungen könnten spezielle
              Sicherheitsvorgaben für Cloud-Dienste und hybride Infrastrukturen
              umfassen, um sicherzustellen, dass sensible Daten auch in diesen
              Umgebungen geschützt sind. Die Vorgaben könnten umfassende
              Richtlinien für die Nutzung und Überwachung von
              Cloud-Dienstleistern enthalten, um sicherzustellen, dass diese den
              gleichen Sicherheitsstandards wie die internen Systeme der
              Finanzinstitute entsprechen. <br />
              <br />
              <strong>
                Verstärkte internationale Kooperation und Harmonisierung der
                Cybersecuritysvorgaben:{" "}
              </strong>
              Da Cyberbedrohungen keine nationalen Grenzen kennen, könnte eine
              engere internationale Zusammenarbeit und Harmonisierung der
              Cybersecuritysstandards für den Finanzsektor erforderlich werden.
              Die EU könnte in enger Abstimmung mit anderen Ländern weltweit
              einheitliche Standards entwickeln, um grenzüberschreitende
              Bedrohungen effektiver zu bekämpfen. Der Austausch von
              Bedrohungsdaten, gemeinsame Krisenübungen und die Koordination von
              Sicherheitsstrategien könnten zu einem festen Bestandteil der
              Cybersecuritysstrategie für Finanzinstitute werden.
            </p>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-10 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter8_4;
